import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import WidgetApp from './WidgetApp.jsx'

// Intentionally does NOT import index.css or register a service worker:
// this bundle is embedded into an arbitrary WordPress theme's page, so it
// must not touch global html/body styles or register a site-wide SW scope.
// (The standalone PWA build in main.jsx is unaffected by this file.)

const container = document.getElementById('allie-chat-widget-root')

if (container) {
  createRoot(container).render(
    <StrictMode>
      <WidgetApp />
    </StrictMode>,
  )
}
